import styled from "styled-components";

const CheckoutStepsContainer = styled.div`
    .after-header {
        .check {
            height: 33px;
            width: 33px;
            border: 1px solid #333;
            border-radius: 50%;
            margin-top: 5px;
        }
    }

    .form-content {
        input,
        select,
        textarea {
            width: 100%;
            line-height: 2;
            padding: 8px 10px;
            background: #fdfdfd;
            border: solid 1px #cccc;
            border-radius: 5px;
            margin-bottom: 20px;
            font-size: 16px;
            &.disabled {
                pointer-events: none !important;
            }
        }
        input,
        select {
            height: 48px;
        }
        input[type="checkbox"],
        input[type="radio"] {
            height: 15px;
            width: 15px;
            margin-bottom: 0px;
            &:not(:last-child) {
                margin-bottom: 18px;
            }
            + span {
                top: -1.5px;
            }
        }

        .form-lt,
        .form-rt,
        .form-ct {
            margin-bottom: 20px;
            > input,
            > select,
            > textarea {
                margin-bottom: 0;
            }
        }
        .form-lt,
        .form-rt {
            width: 50%;
        }
        .form-lt {
            padding-right: 10px;
        }
        .form-rt {
            padding-left: 10px;
        }
        .form-ct {
            width: 100%;
        }

        .btns {
            .btn {
                min-height: 50px;
                background-color: #333;
                color: #fff;
                font-size: 18px;
                padding: 0 0.8em;
                -webkit-transition: opacity 0.2s linear 0s;
                transition: opacity 0.2s linear 0s;
                width: 350px;
                &:hover {
                    background-color: #444;
                }
            }

            .info,
            .create-account-text {
                padding-left: 20px;
            }
        }
        &.step1 {
            .btns {
            }
        }
    }

    .upcoming-steps-view {
        > .head {
            border-bottom: 1px solid #d8d8d8;
            margin-bottom: 15px;
            padding-bottom: 5px;
        }
        .frac {
            margin-bottom: 15px;
            .head {
                margin-bottom: 4px;
            }
            .desc {
                color: #555;
            }
        }
    }

    .shipping-method-label {
        margin-bottom: 20px;
        .main {
            user-select: none;
            border: 2px solid #ccc;
            width: 100%;
            padding: 9px 15px;
            min-height: 65px;

            .round {
                height: 22px;
                width: 22px;
                border-radius: 50%;
                background: #666;

                &::after {
                    content: "";
                    height: 10px;
                    width: 10px;
                    border-radius: 50%;
                    background-color: #fff;
                    opacity: 0;
                }

                .head {
                    margin-bottom: 3px;
                }
            }
        }

        > input {
            &:checked {
                & + .main {
                    border-color: #333;
                    background-color: #efefef;

                    .round {
                        background: #333;
                        &::after {
                            opacity: 1;
                        }
                    }

                    .head {
                    }
                }
            }
        }
    }

    .form-credit-card {
        margin-bottom: 20px;
        > .inner {
            background: #efefef;
            padding: 25px;
            border-radius: 30px;
            max-width: 80%;
        }
    }

    .credit-card-address-details {
    }
`;

export default CheckoutStepsContainer;
